import { createClient } from '@supabase/supabase-js'

// Create a single supabase client for interacting with your database
const supabase = createClient('https://qytfefjtvcvuoptneymj.supabase.co/', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF5dGZlZmp0dmN2dW9wdG5leW1qIiwicm9sZSI6ImFub24iLCJpYXQiOjE2ODc5NTI0NTIsImV4cCI6MjAwMzUyODQ1Mn0.fmEiNuQrv3DrOzC3H4x8rFn_08BTTAONtsRIyqQwUcE')

export default supabase